import React from 'react';
import RoleProvider from "./context/role-context.jsx";
import RoleForm from "./role-form.jsx";

const RoleIndex = () => {
    return (
        <RoleProvider>
            <RoleForm />
        </RoleProvider>
    );
};

export default RoleIndex;